/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useState, useRef, useContext } from 'react'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import Loader from '../../../../components/Loader'
import GlobalContext from '../../../../components/Context/GloablContext'
export default function DeviceTemplateExportFn({ selectedRows, exportDeviceTemplate, exportCols, setIsFilterOpen, isColumnSelect, setIsColumnSelect, isIdexport, username }) {

    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar } = useContext(GlobalContext)
    const [searchParams, setSearchParams] = useSearchParams()

    /* This code is filtering out specific parameters from the `searchParams` object. */
    const excludedParams = ['target_user_name', 'page_number', 'limit'];
    const filteredParams = {};
    let queryString
    if (isIdexport) {
        for (const [key, value] of searchParams.entries()) {
            if (!excludedParams.includes(key)) {
                filteredParams[key] = value;
            }
        }
        filteredParams["sort"] = "timestamp+asc"
        queryString = Object.keys(filteredParams)
            .map(key => `${key}=${encodeURIComponent(filteredParams[key])}`)
            .join('&');
    }

    const [exportLoading, setExportLoading] = useState(false)
    const [isCheckedAll, setIsCheckedAll] = useState(false)
    const [checkedArr, setCheckedArr] = useState(exportCols)
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const ref = useRef()
    /**
    * The function toggles the isCheckedAll state and updates the checkedArr state based on the
    * isCheckedAll value.
    */
    function handleIsCheckedAll() {
        setIsCheckedAll(!isCheckedAll)
        if (!isCheckedAll) {
            setCheckedArr(exportCols)
        }
        else {
            setCheckedArr([])
        }
    }
    /**
   * The `handleExport` function is an asynchronous function that handles exporting data from a device
   * template, converting column names from camel case to snake case, setting loading states, making an
   * API call to export the data, opening the exported file in a new window, and displaying success or
   * error messages.
   */
    async function handleExport() {
        function camelToSnakeCase(str) {
            if (str === "Template ID") {
                return "template_id"
            }
            else if (str === "Template Name") {
                return "template_name"
            }
            else if (str === "Manufacturer") {
                return "manufacturer_name"
            }
            else if (str === "Model") {
                return "model"
            }
            else if (str === "Template Creator") {
                return "template_creator"
            }
            else if (str === "Creation Timestamp") {
                return "created_at"
            }
            else if (str === "Modified Timestamp") {
                return "updated_at"
            }
            else {
                return str.replace(/ /g, '_').toLowerCase();
            }
        }
        let columns
        if (exportCols.includes('Template ID')) {
            columns = checkedArr.map(camelToSnakeCase)
        }
        setExportLoading(true)
        let payload = {}
        let params = Object.fromEntries(searchParams)
        if(params.limit !== ''){
            delete params.limit
        }
        if(params.page_number !== ''){
            delete params.page_number
        }
        isIdexport ? payload= {columns,dateformat,params}:payload={columns,dateformat,params}

        const exportRes = await exportDeviceTemplate(payload)
        setExportLoading(false)
        window.open(exportRes?.data.presigned_url)
        if (exportRes?.error) {
            setToastErrorMessage("Something went wrong")
        }
        else {
            setToastmessage(exportRes?.data?.message)
        }
        setIsColumnSelect(!isColumnSelect)
        setCheckedArr(exportCols)
    }

    /* The `useOnClickOutside` hook is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the `ref` element, which is a
    reference to the div containing the column selection menu. When a click occurs outside of this div,
    the callback function `() => { setIsColumnSelect(false); }` is executed, which sets the
    `isColumnSelect` state to `false`, effectively closing the column selection menu. */
    useOnClickOutside(ref, () => {
        setIsColumnSelect(false);
    });
    
    /**
* The function handles the selection of individual columns by adding or removing them from an
* array.
*/
    function handleIndividualSelect(column) {
        if (checkedArr.includes(column)) {
            let filteredArr = checkedArr?.filter((item) => item !== column)
            setCheckedArr(filteredArr)
            setIsCheckedAll(false)
        }
        else {
            setCheckedArr((prev) => ([
                ...prev,
                column
            ]))
        }
    }

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the effect
    is triggered whenever the `checkedArr` state changes. */
    useEffect(() => {
        if (checkedArr.length === exportCols.length) {
            setIsCheckedAll(true)
        }
        else {
            setIsCheckedAll(false)
        }
    }, [checkedArr])
    
    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered whenever the `isColumnSelect` state changes. */
    useEffect(() => {
        if (isColumnSelect) {
            setIsFilterOpen(false)
            setCheckedArr(exportCols)
        }
    }, [isColumnSelect])


    return (
        <>
            <button id="export" disabled={selectedRows?.length !== 0} onClick={() => { setIsColumnSelect(!isColumnSelect) }} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] 2xl:mb-0 mb-2.5">
                <img src="/images/download-red.svg" alt="download-icon" />
            </button>
            {isColumnSelect &&
                <motion.div
                    initial={{ opacity: 0, x: 80, y: -46 }}
                    animate={{ opacity: 1, x: 0, y: -46 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    exit={{ opacity: 0.5 }}
                    className='z-[999] bg-white absolute 2xl:top-[148px] top-[158px] right-[0px]'
                >
                    <div ref={ref} className='border border-[#EEB9BC] rounded rounded-tr-none rounded-br-none pl-3.5 pr-2.5 py-4 shadow-s4 bg-white min-w-[200px]'>
                        <div className='flex items-center justify-between mb-4'>
                            <p className='text-xs font-semibold text-[#031624]'>Select columns to export</p>
                            <button type='button' onClick={() => setIsColumnSelect(!isColumnSelect)}>
                                <img src="/images/cross_mark_color.svg" alt="icon" />
                            </button>
                        </div>
                        <ul>
                            <li className='flex justify-between items-center mb-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='id1' checked={isCheckedAll} onChange={handleIsCheckedAll} className='prevent-click' />
                                    <label htmlFor='id1' className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">All</label>
                                </div>
                                <button onClick={() => { setCheckedArr([]) }} type='button' className={checkedArr?.length === 0 ? 'hidden' : `text-xs font-semibold text-[#863B50]`}>
                                    Clear All
                                </button>
                            </li>
                            <li className='overflow-y-auto max-h-max4 scrollBar_green_thin'>
                                <ul>
                                    {exportCols.map((column) => (
                                        <li key={column} className='mb-4'>
                                            <div className="relative checkbox custom-checkBoxBlue1">
                                                <input type="checkbox" id={column} onChange={() => handleIndividualSelect(column)} checked={checkedArr.includes(column) ? true : false} className='prevent-click' />
                                                <label htmlFor={column} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">{column}</label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul>
                        <div className='mt-[46px]'>
                            <button id="export-btn" onClick={handleExport} disabled={exportLoading || checkedArr.length === 0}
                                className={`py-2.5 px-4 flex items-center justify-center text-base font-normal text-[#fff] rounded-[16px] 
           ${exportLoading || checkedArr.length === 0 ? 'bg-[#777C88]' : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'}  w-full`}>
                                {!exportLoading && <img src="/images/download_icon_white.svg" alt="icon" />}
                                {exportLoading ? <span className='pl-2.5'>{<Loader />}</span> : <span className='pl-2.5'>Export</span>}
                            </button>
                        </div>
                    </div>
                </motion.div>}
        </>
    )
}
